import { Box, Typography, Modal } from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { modalStyle2 } from "./ModalComponentRecommendations.jsx";

export default function SelectedNoteModal({
  selectedRow,
  setOpenNote,
  openNote,
}) {
  const { t } = useTranslation("recommendations");

  // console.log("current recommendation in selected note modal: ", selectedRow);
  return (
    <Modal open={openNote} onClose={() => setOpenNote(false)}>
      <Box sx={modalStyle2}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
          }}
        >
          <Typography variant="h5" sx={{ pb: 2 }}>
            {t("title.noteDetails")}
          </Typography>
          <IconButton onClick={() => setOpenNote(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{ pb: 2 }}>
            <strong>{t("labels.recommendationLabel")}</strong> <br /> {selectedRow.recommendation}
          </Typography>
          <Typography variant="p">
            <strong>{t("labels.noteLabel")}</strong> <br /> {selectedRow.notes}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}
